const rolesActionTypes =  {    
    RETRIEVED_GROUPS_LIST: "RETRIEVED_GROUPS_LIST",
    RETRIEVED_ROLES_LIST: "RETRIEVED_ROLES_LIST",
    UPDATE_ROLEGROUP: "UPDATE_ROLEGROUP",
    DELETE_ROLEGROUP: "DELETE_ROLEGROUP",
    UPDATE_ROLE: "UPDATE_ROLE",
    DELETE_ROLE: "DELETE_ROLE",
    DELETE_USER_FROM_ROLE: "DELETE_USER_FROM_ROLE"
};
export default rolesActionTypes;
